import { render, staticRenderFns } from "./ManCompany.vue?vue&type=template&id=0958b653&scoped=true&lang=pug&"
import script from "./ManCompany.vue?vue&type=script&lang=js&"
export * from "./ManCompany.vue?vue&type=script&lang=js&"
import style0 from "./ManCompany.vue?vue&type=style&index=0&id=0958b653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958b653",
  null
  
)

export default component.exports